import type { User } from 'firebase/auth';

interface AuthState {
  user: User | null;
}

const TEST_MODE_KEY = 'gd-test-uid';

const state: AuthState = { user: null };

export function setAuthState(patch: Partial<AuthState>): void {
  Object.assign(state, patch);
}

function getTestModeUid(): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  return sessionStorage.getItem(TEST_MODE_KEY);
}

export async function getIdToken(forceRefresh = false): Promise<string | null> {
  if (getTestModeUid()) return null;
  if (!state.user) return null;
  return await state.user.getIdToken(forceRefresh);
}

export function getTestModeHeaders(): Record<string, string> {
  const uid = getTestModeUid();
  return uid ? { 'X-Dev-Uid': uid } : {};
}

export function getCurrentSessionId(): string {
  let sid = sessionStorage.getItem('gd-session-id');
  if (!sid) {
    sid = `cli-${crypto.randomUUID()}`;
    sessionStorage.setItem('gd-session-id', sid);
  }
  return sid;
}

export function triggerForceSignOut(reason: string): void {
  console.warn('Forcing sign-out:', reason);
  sessionStorage.removeItem('gd-session-id');
  state.user = null;
  window.location.reload();
}
